<template>
  <hs-card class="ui-table-shell" padding="none">
    <div v-if="$slots.header || title" class="ui-table-shell__header">
      <slot name="header">
        <hs-section-header :kicker="kicker" :title="title" :description="description">
          <template v-if="$slots.actions" #actions>
            <slot name="actions" />
          </template>
        </hs-section-header>
      </slot>
    </div>

    <div v-if="$slots.filters" class="ui-table-shell__filters">
      <slot name="filters" />
    </div>

    <div class="ui-table-shell__body">
      <slot />
    </div>

    <div v-if="$slots.footer" class="ui-table-shell__footer">
      <slot name="footer" />
    </div>
  </hs-card>
</template>

<script>
import HsCard from "./HsCard.vue";
import HsSectionHeader from "./HsSectionHeader.vue";

export default {
  name: "HsTableShell",
  components: { HsCard, HsSectionHeader },
  props: {
    kicker: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.ui-table-shell {
  overflow: hidden;
  min-width: 0;
}

.ui-table-shell__header,
.ui-table-shell__filters,
.ui-table-shell__footer {
  border-bottom: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
  padding: 1rem;
}

.ui-table-shell__filters {
  background: color-mix(in srgb, var(--hs-bg-soft, #f1f5f9) 45%, transparent);
}

.ui-table-shell__body {
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.ui-table-shell__footer {
  border-bottom: 0;
  border-top: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
}
</style>
